import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";
import { Section, LinkDecor } from "@vshp/ui-components";
import i18n from "i18next";

function ITCourses() {
  const { t } = useTranslation();
  let locale = i18n.language;

  let title = {
    caption: t("pages.it_courses.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.it_courses.title")} titleKey="pages.it_courses.title" isWidthSmall={true}>
        <Section data-key="pages.it_courses.text" dangerouslySetInnerHTML={{ __html: t("pages.it_courses.text") }}></Section>
        <Section>
          {locale !== "ru" ? (
            <>
              <LinkDecor link="/docs/9ab2/AIBS_Summary.pdf">AI Business Specialist</LinkDecor>
              <LinkDecor link="/docs/9ab0/CSS_Two_Page_Summary.pdf">Cyber Security Specialist</LinkDecor>
              <LinkDecor link="/docs/9ab1/DCS_Two_Page_Summary.pdf">Digital Collaboration</LinkDecor>
              <LinkDecor link="/docs/9aaf/Information_Security_Manager_Two_Page_Summary.pdf">Information Security Manager</LinkDecor>
            </>
          ) : (
            <>
              <LinkDecor link="/docs/9adf/AIBS_Spetsialist_po_II_v_biznese_RU.pdf">Специалист по ИИ в бизнесе</LinkDecor>
              <LinkDecor link="/docs/9ae1/CSS_Spetsialist_po_kiberbezopasnosti_RU.pdf">Специалист по кибербезопасности</LinkDecor>
              <LinkDecor link="/docs/9ae0/DCS_Spetsialist_po_tsifrovomu_vzaimodeĭstviyu_RU.pdf">Специалист по цифровому взаимодействию</LinkDecor>
              <LinkDecor link="/docs/9ae2/Menedzher_po_informatsionnoĭ_bezopasnosti_RU.pdf">Менеджер по информационной безопасности</LinkDecor>
            </>
          )}
        </Section>
      </Page>
    </MainLayout>
  );
}

export default ITCourses;
